<template>
  <div class="h-full bg-white dark:bg-gray-900 flex flex-col relative">
    <div
      v-if="currentStepIndex <= maxSteps"
      class="flex justify-between items-center gap-10 lg:absolute top-0 left-0 w-full z-10 px-5 my-5 lg:px-12"
    >
      <div>
        <l-button
          v-if="currentStepIndex && currentStepIndex <= maxSteps"
          class="text-gray-500 text-left inline-flex gap-1 items-center hover:text-gray-700"
          @click="() => back()"
        >
          <icon name="chevronLeft" set="regular" class="text-sm"/>
          Back
        </l-button>
      </div>
      <div>
        <l-button
          class="text-gray-500 text-left hover:text-gray-700"
          aria-label="Back to home"
          @click="close"
        >
          <icon set="regular" name="close"/>
        </l-button>
      </div>
    </div>

    <component
      :is="steps[currentStepIndex]"
      v-model="user"
      :max-steps="maxSteps"
      :step="currentStepIndex"
      :loading="loading"
      :loading-text="loadingText"
      @back="back"
      @next="next"
    />

    <modal
      :show="showErrorModal"
      @close="showErrorModal = false"
    >
      <template #title>
        Failed to create personal report
      </template>

      <template #body>
        <div class="space-y-3">
          <p>
            Please contact an administrator.
          </p>
          <l-button
            variant="primary"
            size="lg"
            @click="reset"
          >
            Try again
          </l-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import Modal from "@/components/modals/Modal.vue"
import { computed, ref } from "vue"

const user = defineModel({ type: Object, required: true })

const props = defineProps({
  loadingText: { type: String, default: "Loading" },
  steps: { type: Array, required: true },
  save: { type: Function, required: true },
})

const currentStepIndex = ref(0)
const showErrorModal = ref(false)
const loading = ref(false)

const maxSteps = computed(() => props.steps.length - 1)

const back = (step = null) => {
  const index = step ? props.steps.indexOf(step) : currentStepIndex.value - 1

  if (index >= 0) {
    currentStepIndex.value = index
  }
}

const next = () => {
  if (currentStepIndex.value >= maxSteps.value) {
    return
  }

  if ((maxSteps.value - currentStepIndex.value) <= 1) {
    loading.value = true

    // submit
    props.save()
      .then(() => {
        currentStepIndex.value += 1
      })
      .catch(() => {
        showErrorModal.value = true
      })
      .finally(() => {
        loading.value = false
      })
  } else {
    currentStepIndex.value += 1
  }
}

const close = () => {
  history.back()
}

const reset = () => {
  showErrorModal.value = false
}
</script>
